var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-popconfirm',{attrs:{"title":_vm.title},on:{"onConfirm":_vm.onConfirm,"onCancel":_vm.onCancel}},[_c('el-button',{attrs:{"slot":"reference","type":_vm.type,"size":_vm.size,"icon":_vm.icon},slot:"reference"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }